import React, { useState } from 'react';
import { Download, Share, X } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { useInstallPrompt } from '../hooks/useInstallPrompt';

const DISMISS_KEY = 'installBannerDismissed';

export const InstallAppBanner = () => {
  const { language } = useLanguage();
  const { installed, canPrompt, ios, install } = useInstallPrompt();
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(DISMISS_KEY) === '1');
  const fr = language === 'fr';

  if (installed || dismissed || (!canPrompt && !ios)) return null;

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, '1');
    setDismissed(true);
  };

  return (
    <div className="md:hidden px-4 pt-3 animate-fade-in" data-testid="install-app-banner">
      <div className="flex items-center gap-3 rounded-2xl bg-white border border-gray-100 shadow-md p-3">
        <img src="/icon-192.png" alt="" className="w-11 h-11 rounded-xl flex-shrink-0" />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-gray-900">{fr ? "Installez l'application" : 'Install the app'}</p>
          {ios ? (
            <p className="text-xs text-gray-600 leading-snug" data-testid="install-ios-instructions">
              {fr ? 'Touchez ' : 'Tap '}
              <Share className="inline w-3.5 h-3.5 -mt-0.5" />
              {fr ? " puis « Sur l'écran d'accueil »" : ' then "Add to Home Screen"'}
            </p>
          ) : (
            <p className="text-xs text-gray-600">{fr ? "Accès rapide depuis votre écran d'accueil" : 'Quick access from your home screen'}</p>
          )}
        </div>
        {!ios && (
          <button
            onClick={install}
            className="flex-shrink-0 inline-flex items-center gap-1 h-9 px-3 rounded-full bg-primary text-white text-sm font-semibold"
            data-testid="install-app-btn"
          >
            <Download className="w-4 h-4" />
            {fr ? 'Installer' : 'Install'}
          </button>
        )}
        <button
          onClick={dismiss}
          className="flex-shrink-0 w-9 h-9 flex items-center justify-center rounded-full text-gray-400 hover:bg-gray-100"
          aria-label={fr ? 'Fermer' : 'Close'}
          data-testid="install-banner-close"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};
